export default "__VITE_ASSET__BjQIppNX__"